import React, { useState } from "react";
import logo from "../logo-vpvv.png";
// import "./Iceremony.css";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
// import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

const IcBloodDetails = () => {
  const [lgShow, setLgShow] = useState(true);
  // const [numGuests, setNumGuests] = useState(1); // Default 1 guest
  const location = useLocation();
  const [numGuests, setNumGuests] = useState(location.state?.numGuests || 1);
  const IcTravelDetails = useNavigate();
  const gotoIcTravelDetails = () => {
    IcTravelDetails("/IcTravelDetails", { state: { numGuests } });
  };
  const [step, setSteps] = useState(3);

  return (
    <>
      {/* Main Container */}
      <div className="ic-container">
        <img src={logo} alt="logo" style={{ width: "150px" }} />
        <h2 style={{ color: "white" }}>
          VPVV TECHNO CONSTRUCTION PRIVATE LIMITED
        </h2>

        {/* Dynamically Render Forms */}
        <div className="ic-form">
          <h2 className="form-title">Blood Test Report</h2>
          <div className="progress_container">
            <div className={`${step >= 1 ? "circle active" : "circle"}`}>1</div>
            <div className={`${step >= 2 ? "circle active" : "circle"}`}>2</div>
            <div className={`${step >= 3 ? "circle active" : "circle"}`}>3</div>
            <div className={`${step >= 4 ? "circle active" : "circle"}`}>4</div>
            <div className={`${step >= 5 ? "circle active" : "circle"}`}>5</div>
          </div>
          {Array.from({ length: numGuests }).map((_, index) => (
            <div key={index}>
              <h5 className="guestSeries">Guest {index + 1}</h5>

              {/* Blood Test Report */}
              <Form>
                <Form.Group controlId="formFile" className="mb-3">
                  <Form.Label>Uplod Blood Test Report</Form.Label>
                  <Form.Control type="file" required />
                </Form.Group>
                <Form.Control
                  as="textarea"
                  placeholder="Write a Description"
                  style={{ height: "100px" }}
                  required
                />
              </Form>
            </div>
          ))}
          <Button
            variant="primary"
            type="submit"
            style={{ width: "670px", marginTop: "1rem" }}
            onClick={gotoIcTravelDetails}
          >
          Save & Continue
          </Button>
        </div>
      </div>
    </>
  );
};

export default IcBloodDetails;
